// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.object-card--dropdown,
.object-card--input,
.object-card--checkbox {
  width: calc(100% - 140px);
}

#custom-cardscroll.p-card {
  margin-top: 0;
}

.error-tab .p-tabview-title {
  color: red;
}

.fixed-labels {
  max-width: 200px;
}

.laborAccountingCoefficient input {
  width: 4rem;
}

.task-card .col {
  width: calc(100% - 166px);
}

.p-card {
  border: 1px solid rgb(211, 211, 211) !important;
}

.task-card--tag-scroll .tag-component {
  margin: 0;
  padding-bottom: 0.5rem;
}

.action-section .p-placeholder {
  white-space: break-spaces;
}

.details-card__input {
  width: 370px;
}

.details-card__input input {
  width: 100%;
}

.task-card .mainTab-task-card .p-card .p-card-body {
  padding: 0.75rem;
}

.task-card .mainTab-task-card .executor-tags-container {
  /* transition: all 0.2s; */
  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-color: #6366f1 !important;
  }
}

.task-card .p-disabled,
.p-component:disabled {
  opacity: 1;
}

.task-card .p-datatable-row-expansion > td {
  padding: 0 !important;
}

.task-card .p-datatable.p-datatable-sm .p-datatable-footer {
  padding-left: 0;
  padding-right: 0;
}

.task-card .task-card__label {
  width: 150px !important;
}

.actualStartDatePanel,
.plannedEndDatePanel,
.actualEndDatePanel {
  min-width: 157px !important;
  width: 357px !important;
}

.task-card .actual-operations--employees-dropdown {
  text-align: left;
  white-space: nowrap;
}

.task-card .actual-operations-operation-dropdown-wrapper {
  max-width: 100% !important;
  width: 100% !important;
}

.task-card {
  --task-field-label-width: 150px;
  --task-field-input-height: 42px;
  --task-field-input-padding: 0.75rem;
  --task-field-gap: 7px;
}

.task-field-row--spaced {
  padding-bottom: var(--task-field-gap);
}

.task-card__label--fixed {
  width: var(--task-field-label-width);
  padding: 0;
}

.task-card__label--narrow {
  width: 130px;
}

.task-card__label--action {
  width: var(--task-field-label-width);
  padding: 0;
  font-weight: 500;
}

.task-card__field-input {
  padding: var(--task-field-input-padding);
  margin-bottom: var(--task-field-gap);
  height: var(--task-field-input-height);
}

.task-card__employee-tags {
  overflow: hidden;
  margin-bottom: 16px;
  margin-right: 0;
  max-height: 84px;
  min-height: 50px;
  padding: 5px 0.5rem 3rem 0.65rem;
  border-radius: 6px;
}

.task-card__tags-scroll {
  width: 100%;
  max-height: 84px;
  overflow: auto;
}

.task-card__tags-scroll--padded {
  padding-top: 5px;
}

.task-card__planned-ops-scroll {
  width: 100%;
  max-height: 93px;
  min-height: 42px;
  overflow: auto;
  align-content: center;
  margin-bottom: 16px;
  border: 1px solid rgb(211, 211, 211);
  border-radius: 5px;
}

.task-card-header__copy-icon {
  color: rgba(178, 178, 178, 1);
  cursor: pointer;
}

.task-card__asset-warning {
  margin-top: 32.5px;
}

.task-card__asset-warning-icon {
  color: rgb(255, 168, 0);
  font-size: 1.2rem;
}

.actual-ops__add-btn.p-button {
  width: 2.75rem;
  height: 2.75rem;
  min-width: 2.75rem;
  padding: 0;
  border-radius: 50%;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .task-card-header {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .task-card-header__subtitle {
    display: none;
  }

  .task-card-header__buttons {
    flex-wrap: wrap;
  }

  .task-card-header__export-btn {
    display: none !important;
  }

  .mainTab-task-card .grid {
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .mainTab-task-card .grid > .task-card__column {
    flex: 1 1 100%;
    width: 100%;
    margin-right: 0 !important;
  }

  .mainTab-task-card .task-field-row > .grid,
  .task-card__description-row,
  .task-card__actions-row {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: stretch !important;
    gap: 0.25rem;
    margin: 0;
  }

  .task-card .fixed-labels,
  .task-card .task-card__label--fixed,
  .task-card .task-card__label--narrow,
  .task-card .task-card__label--action,
  .mainTab-task-card .col-4 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
  }

  .task-card .col {
    flex: 0 0 auto !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
    padding: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    overflow: visible !important;
  }

  .task-card input.col {
    padding-left: 10px!important;
  }

  .task-card .task-field-row,
  .task-card .task-field-row > .grid,
  .task-card__description-row,
  .task-card__actions-row,
  .task-card__planned-ops-row,
  .task-card__planned-ops-row > div {
    min-width: 0 !important;
  }

  .task-card .p-inputtext,
  .task-card .p-inputtextarea,
  .task-card .p-dropdown,
  .task-card .p-calendar,
  .task-card .custom-dropdown-wrapper {
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .task-card .col.flex {
    flex-wrap: nowrap;
  }

  .task-card .col.flex .custom-dropdown-wrapper {
    flex: 1 1 auto !important;
    width: auto !important;
    min-width: 0 !important;
  }

  .mainTab-task-card .task-card__description-row .p-inputtextarea,
  .task-card__employee-tags,
  .task-card__tags-scroll {
    width: 100% !important;
  }

  .task-card__actions-row {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .task-card-transitions-btns__roles .action-section {
    flex-direction: column;
    align-items: stretch;
    margin-right: 0 !important;
    padding: 0 !important;
  }

  .task-card-transitions-btns__roles .action-section .p-button,
  .task-card-transitions-btns__roles .action-section .p-dropdown {
    width: 100%;
  }

  .task-card__column {
    margin-right: 0 !important;
  }

  .task-card__planned-ops-row {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.25rem;
  }

  .actualOperations-table {
    -webkit-overflow-scrolling: touch;
  }

  .task-comments {
    padding: 0.75rem !important;
  }

  .task-comments .p-scrollpanel {
    height: 55vh !important;
  }

  .task-comments .flex.justify-content-between.align-items-center.mt-2 {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .task-map-dialog.p-dialog {
    height: 90vh !important;
    max-height: 90vh;
  }

  .task-map-dialog__layout {
    flex-direction: column !important;
  }

  .task-map-dialog__map {
    min-height: 300px !important;
    padding: 12px !important;
  }

  .task-map-dialog__side {
    width: 100% !important;
    padding: 0 12px 12px !important;
    max-height: 45vh;
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/TaskCard.css"],"names":[],"mappings":"AAAA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;IACE,wCAAwC;IACxC,gCAAgC;EAClC;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,0BAA0B;EAC5B;;EAEA;;;IAGE,iCAAiC;IACjC,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,SAAS;EACX;;EAEA;;;;;IAKE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;;;;;IAME,uBAAuB;EACzB;;EAEA;;;;;IAKE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".object-card--dropdown,\n.object-card--input,\n.object-card--checkbox {\n  width: calc(100% - 140px);\n}\n\n#custom-cardscroll.p-card {\n  margin-top: 0;\n}\n\n.error-tab .p-tabview-title {\n  color: red;\n}\n\n.fixed-labels {\n  max-width: 200px;\n}\n\n.laborAccountingCoefficient input {\n  width: 4rem;\n}\n\n.task-card .col {\n  width: calc(100% - 166px);\n}\n\n.p-card {\n  border: 1px solid rgb(211, 211, 211) !important;\n}\n\n.task-card--tag-scroll .tag-component {\n  margin: 0;\n  padding-bottom: 0.5rem;\n}\n\n.action-section .p-placeholder {\n  white-space: break-spaces;\n}\n\n.details-card__input {\n  width: 370px;\n}\n\n.details-card__input input {\n  width: 100%;\n}\n\n.task-card .mainTab-task-card .p-card .p-card-body {\n  padding: 0.75rem;\n}\n\n.task-card .mainTab-task-card .executor-tags-container {\n  /* transition: all 0.2s; */\n  &:hover {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-color: #6366f1 !important;\n  }\n}\n\n.task-card .p-disabled,\n.p-component:disabled {\n  opacity: 1;\n}\n\n.task-card .p-datatable-row-expansion > td {\n  padding: 0 !important;\n}\n\n.task-card .p-datatable.p-datatable-sm .p-datatable-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.task-card .task-card__label {\n  width: 150px !important;\n}\n\n.actualStartDatePanel,\n.plannedEndDatePanel,\n.actualEndDatePanel {\n  min-width: 157px !important;\n  width: 357px !important;\n}\n\n.task-card .actual-operations--employees-dropdown {\n  text-align: left;\n  white-space: nowrap;\n}\n\n.task-card .actual-operations-operation-dropdown-wrapper {\n  max-width: 100% !important;\n  width: 100% !important;\n}\n\n.task-card {\n  --task-field-label-width: 150px;\n  --task-field-input-height: 42px;\n  --task-field-input-padding: 0.75rem;\n  --task-field-gap: 7px;\n}\n\n.task-field-row--spaced {\n  padding-bottom: var(--task-field-gap);\n}\n\n.task-card__label--fixed {\n  width: var(--task-field-label-width);\n  padding: 0;\n}\n\n.task-card__label--narrow {\n  width: 130px;\n}\n\n.task-card__label--action {\n  width: var(--task-field-label-width);\n  padding: 0;\n  font-weight: 500;\n}\n\n.task-card__field-input {\n  padding: var(--task-field-input-padding);\n  margin-bottom: var(--task-field-gap);\n  height: var(--task-field-input-height);\n}\n\n.task-card__employee-tags {\n  overflow: hidden;\n  margin-bottom: 16px;\n  margin-right: 0;\n  max-height: 84px;\n  min-height: 50px;\n  padding: 5px 0.5rem 3rem 0.65rem;\n  border-radius: 6px;\n}\n\n.task-card__tags-scroll {\n  width: 100%;\n  max-height: 84px;\n  overflow: auto;\n}\n\n.task-card__tags-scroll--padded {\n  padding-top: 5px;\n}\n\n.task-card__planned-ops-scroll {\n  width: 100%;\n  max-height: 93px;\n  min-height: 42px;\n  overflow: auto;\n  align-content: center;\n  margin-bottom: 16px;\n  border: 1px solid rgb(211, 211, 211);\n  border-radius: 5px;\n}\n\n.task-card-header__copy-icon {\n  color: rgba(178, 178, 178, 1);\n  cursor: pointer;\n}\n\n.task-card__asset-warning {\n  margin-top: 32.5px;\n}\n\n.task-card__asset-warning-icon {\n  color: rgb(255, 168, 0);\n  font-size: 1.2rem;\n}\n\n.actual-ops__add-btn.p-button {\n  width: 2.75rem;\n  height: 2.75rem;\n  min-width: 2.75rem;\n  padding: 0;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .task-card-header {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .task-card-header__subtitle {\n    display: none;\n  }\n\n  .task-card-header__buttons {\n    flex-wrap: wrap;\n  }\n\n  .task-card-header__export-btn {\n    display: none !important;\n  }\n\n  .mainTab-task-card .grid {\n    margin: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .mainTab-task-card .grid > .task-card__column {\n    flex: 1 1 100%;\n    width: 100%;\n    margin-right: 0 !important;\n  }\n\n  .mainTab-task-card .task-field-row > .grid,\n  .task-card__description-row,\n  .task-card__actions-row {\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n    align-items: stretch !important;\n    gap: 0.25rem;\n    margin: 0;\n  }\n\n  .task-card .fixed-labels,\n  .task-card .task-card__label--fixed,\n  .task-card .task-card__label--narrow,\n  .task-card .task-card__label--action,\n  .mainTab-task-card .col-4 {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 !important;\n  }\n\n  .task-card .col {\n    flex: 0 0 auto !important;\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n    padding: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    overflow: visible !important;\n  }\n\n  .task-card input.col {\n    padding-left: 10px!important;\n  }\n\n  .task-card .task-field-row,\n  .task-card .task-field-row > .grid,\n  .task-card__description-row,\n  .task-card__actions-row,\n  .task-card__planned-ops-row,\n  .task-card__planned-ops-row > div {\n    min-width: 0 !important;\n  }\n\n  .task-card .p-inputtext,\n  .task-card .p-inputtextarea,\n  .task-card .p-dropdown,\n  .task-card .p-calendar,\n  .task-card .custom-dropdown-wrapper {\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box;\n  }\n\n  .task-card .col.flex {\n    flex-wrap: nowrap;\n  }\n\n  .task-card .col.flex .custom-dropdown-wrapper {\n    flex: 1 1 auto !important;\n    width: auto !important;\n    min-width: 0 !important;\n  }\n\n  .mainTab-task-card .task-card__description-row .p-inputtextarea,\n  .task-card__employee-tags,\n  .task-card__tags-scroll {\n    width: 100% !important;\n  }\n\n  .task-card__actions-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n  }\n\n  .task-card-transitions-btns__roles .action-section {\n    flex-direction: column;\n    align-items: stretch;\n    margin-right: 0 !important;\n    padding: 0 !important;\n  }\n\n  .task-card-transitions-btns__roles .action-section .p-button,\n  .task-card-transitions-btns__roles .action-section .p-dropdown {\n    width: 100%;\n  }\n\n  .task-card__column {\n    margin-right: 0 !important;\n  }\n\n  .task-card__planned-ops-row {\n    flex-direction: column;\n    align-items: stretch !important;\n    gap: 0.25rem;\n  }\n\n  .actualOperations-table {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .task-comments {\n    padding: 0.75rem !important;\n  }\n\n  .task-comments .p-scrollpanel {\n    height: 55vh !important;\n  }\n\n  .task-comments .flex.justify-content-between.align-items-center.mt-2 {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .task-map-dialog.p-dialog {\n    height: 90vh !important;\n    max-height: 90vh;\n  }\n\n  .task-map-dialog__layout {\n    flex-direction: column !important;\n  }\n\n  .task-map-dialog__map {\n    min-height: 300px !important;\n    padding: 12px !important;\n  }\n\n  .task-map-dialog__side {\n    width: 100% !important;\n    padding: 0 12px 12px !important;\n    max-height: 45vh;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
